import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { Reveal } from './Reveal';
export function Bonuses() {
  return <section className="bg-white py-20 sm:py-28" aria-labelledby="bonos-title" data-id="element-15" data-mp="pm2bbv98hdgi">
      <div className="mx-auto max-w-6xl px-6" data-id="element-16" data-mp="aujz88jhw32f">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.8fr)] lg:items-end" data-id="element-17" data-mp="ftwkioupx22w">
          <Reveal data-id="element-18" data-mp="1un53rec6bzz">
            <p className="inline-flex items-center gap-2 rounded-full bg-mint-50 px-3.5 py-1.5 text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200" data-id="element-19" data-mp="1u5bz3mz0dwa">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="5tnmr6l2v8le" />
              Incluidos sin costo extra
            </p>
            <h2 id="bonos-title" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-21" data-mp="3t0g4uchtu8cj">
              Más los 6 bonos estratégicos
            </h2>
            <p className="mt-4 max-w-xl text-lg text-ink-soft" data-id="element-22" data-mp="1r9bfjn3d9jvd">
              Las herramientas que convierten el protocolo en algo que podés
              sostener en la vida real: viajes, salidas, recaídas y días difíciles.
            </p>
          </Reveal>

          <Reveal delay={0.06} data-id="element-23" data-mp="3detuaueskqs1">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/65064ee9-49a2-461a-935b-54fbbc592cce.jpg" alt="Los 6 bonos del MegaPack presentados como cuadernillos" className="w-full rounded-2xl object-cover" width={900} height={600} data-id="element-24" data-mp="3ddiokp1sd8ya" />
          </Reveal>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="2zhoiedsecxov">
          {bonos.map((bono, index) => <li key={bono.number} className="flex" data-id="element-26" data-mp="2uikb5sp19a16" data-mpi={index}>
              <Reveal delay={index * 0.04} className="flex h-full w-full flex-col rounded-2xl border border-mint-200 bg-mint-50/60 p-7" data-id="element-27" data-mp="38hbjszl4m3hx">
                <p className="text-xs font-semibold uppercase tracking-[0.16em] text-mint-600" data-id="element-28" data-mp="33fumtf5rj16m">
                  Bono {bono.number}
                </p>
                <h3 className="mt-3 font-display text-xl leading-snug text-ink" data-id="element-29" data-mp="irq1qpjjuuaq">
                  {bono.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-30" data-mp="3ciekez4q7mwz">
                  {bono.description}
                </p>
                <p className="mt-auto flex items-baseline gap-2 pt-6" data-id="element-31" data-mp="3ljl4tjahxhvi">
                  <span className="text-sm text-ink-muted line-through" data-id="element-32" data-mp="3lke1tsjnkt0g">
                    {bono.price}
                  </span>
                  <span className="text-sm font-semibold uppercase tracking-wide text-mint-700" data-id="element-33" data-mp="2tseyum83gpyb">
                    Gratis
                  </span>
                </p>
              </Reveal>
            </li>)}
        </ul>

        <Reveal delay={0.04} data-id="element-34" data-mp="32sleoer9m20n">
          <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-2xl bg-mint-600 px-8 py-7 text-white sm:flex-row sm:items-center" style={{
          alignItems: "center",
          justifyContent: "center"
        }} data-id="element-35" data-mp="32rjzpz74ovdn">
            <div data-id="element-36" data-mp="2f3iuaz58xv2g">
              <p className="text-sm uppercase tracking-[0.16em] text-mint-100" data-id="element-37" data-mp="2f30p3d0lw6ie">
                Valor total de los 6 bonos
              </p>
              <p className="mt-1 font-display text-3xl" data-id="element-38" data-mp="27jhro1qm8aqa">
                USD 63.00 <span className="text-mint-100" data-id="element-39" data-mp="22kna134dws7r">— hoy gratis</span>
              </p>
            </div>
            
          </div>
        </Reveal>
      </div>
    </section>;
}